<template>
    <div class="barchart">
        <div class="text-xs-center">
            <h5>{{ title }}</h5>
        </div>
        <ve-bar :data="chartData" :legend-visible="false" :toolbox="toolbox"></ve-bar>
    </div>
</template>

<script>
export default {
    props: {
        title: { type: String, required: false, default: null },
        cols: { type: Array, required: false, default: null },
        data: { type: Array, required: false, default: null }
    },
    data() {
        return {
            chartData: {
                columns: this.cols,
                rows: this.data
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title: "Salvar imagen"
                    }
                }
            }
        }
    }
}
</script>
